var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoAvgSalary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13C21 14.1046 18.5376 15 15.5 15C12.4624 15 10 14.1046 10 13M21 13C21 11.8954 18.5376 11 15.5 11C12.4624 11 10 11.8954 10 13M21 13V14.5M10 13V25C10 26.1046 12.4624 27 15.5 27M15.5 19C15.3315 19 15.1647 18.9972 15 18.9918C12.1967 18.9 10 18.0433 10 17M15.5 23C12.4624 23 10 22.1046 10 21M30 19.5C30 20.6046 27.5376 21.5 24.5 21.5C21.4624 21.5 19 20.6046 19 19.5M30 19.5C30 18.3954 27.5376 17.5 24.5 17.5C21.4624 17.5 19 18.3954 19 19.5M30 19.5V27C30 28.1046 27.5376 29 24.5 29C21.4624 29 19 28.1046 19 27V19.5M30 23.25C30 24.3546 27.5376 25.25 24.5 25.25C21.4624 25.25 19 24.3546 19 23.25",
    stroke: "#118F84",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoAvgSalary);
export default __webpack_public_path__ + "static/media/info-avgSalary.2ca4c315c787bfb9b7f123c66626f61c.svg";
export { ForwardRef as ReactComponent };